export default "__VITE_ASSET__I2xfrGnD__"